import { render, staticRenderFns } from "./ProfessionPageHeading.vue?vue&type=template&id=28db05c2"
import script from "./ProfessionPageHeading.vue?vue&type=script&lang=js"
export * from "./ProfessionPageHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports